// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"809":"a1dc56b4","816":"6cb35638","997":"8d0ba773"}[chunkId] + ".chunk.js";
};